"use client";

import { ReactNode } from "react";
import {SessionHeartbeatProvider} from "@/components/providers/sessionHeartbeatProvider";

type Props = {
    children: ReactNode;
};

export default function ClientLayoutWrapper({ children }: Props) {
    return (
        <>
            <SessionHeartbeatProvider />
            {children}
        </>
    );
}
